/**
 * O NOME DO CLIENTE NA TELA (pedido do Heitor, 28/10/2026). Em todas as telas, o nome é o "Nome (Exibição)" do cadastro
 * (`name`: "Este nome será usado para exibição no sistema"). Fantasia e razão social só entram quando o `name` estiver
 * vazio, nessa ordem. Antes, 45 pontos do front escolhiam por conta própria, com a fantasia (ou a razão) na frente, e o
 * mesmo cliente aparecia com nomes diferentes de uma tela para outra.
 *
 * Documento que vai para fora (destinatário de ofício, contrato) não usa isto: lá vale a razão social.
 */
export type ClienteComNome = { name?: string | null; tradeName?: string | null; companyName?: string | null } | null | undefined;

export function nomeDeExibicao(c: ClienteComNome, reserva = ''): string {
  for (const v of [c?.name, c?.tradeName, c?.companyName]) {
    const t = String(v ?? '').trim();
    if (t) return t;
  }
  return reserva;
}
